<template>
  <v-footer height="auto">
    <v-container>
      <v-layout wrap pa-5 mt-6 mb-6>
        <v-flex xs12 mb-8 class="text-left">
          <img class="footer-logo" src="../assets/logo.png" alt="Toursol">
        </v-flex>
        <v-flex xs12 sm6 class="text-left">
          <div>TourSol GmbH</div>
          <div>Wängler Str. 6</div>
          <div>6600 Lechaschau</div>
          <a href="mailto:info@toursol.at" class="info-mail-link">info@toursol.at</a>
          <div>
            &copy; {{new Date().getFullYear()}} — <strong>{{$t('rights')}}</strong>
          </div>
        </v-flex>
        <v-flex xs12 sm6>
          <v-layout wrap class="text-left footer-menu-container">
            <v-flex xs12 sm6 offset-sm6 class="border">
              <v-btn text medium color="primary" @click="goTo('Privacy')">{{$t('privacyPolicy')}}</v-btn>
            </v-flex>
            <v-flex xs12 sm6 offset-sm6 class="border">
              <v-btn text medium color="primary" @click="goTo('Impressum')">{{$t('imprint')}}</v-btn>
            </v-flex>
            <v-flex xs12 sm6 offset-sm6 class="border">
              <v-btn text medium color="primary" @click="goTo('Agb')">{{$t('conditionsShort')}}</v-btn>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
  </v-footer>
</template>

<script>
  export default {
    name: 'footer',
    methods: {
      goTo(page) {
        this.$router.push({name: page});
      }
    }
  }
</script>

<style lang="scss">
  @import "../assets/scss/layout";
  @import "../assets/scss/variables";
  .v-footer {
    background: linear-gradient(to bottom, #f0f0f0 5%, transparent),
    url('https://toursol.at/static/images/background.png') no-repeat center center fixed;
    background-size: cover;
    .footer-logo {
      height: 40px;
    }
    .info-mail-link {
      margin-top: 25px;
      margin-bottom: 20px;
      font-weight: 600;
      text-decoration: none;
      display: inline-block;
    }
    .footer-menu-container {
      @include MQ(XS) {
        margin-top: 35px;
      }
      .border {
        border-left: 2px solid $primary;
      }
      .v-btn {
        .v-btn__content {
          font-size: 16px;
        }
      }
    }
  }
</style>
